export const ParseArrayToQueryParams = (arr: any) => (arr.length > 0) ? arr.split(',') : [];
export const ParseArrayToQueryParamsNumber = (arr: any) => (arr.length > 0) ? arr.split(',').map((m: any) => +m) : [];
export const ParseArrayToQueryParamsFilter = (arr: any) => (arr.length > 0) ? arr.split(',').map((m: any) => +m).filter((f: any, i: number, arr: any) => arr.indexOf(f) == i) : [];
export const SetArrayToQueryParams = (arr: any) => (arr.length > 0) ? arr.join(",") : [];
export const ConvertStringToNumber = (val: string) => +val;
